<template>
	<div class="main_display" v-if="!ExhibitDetail.uuid">
		<div class="m">
			<div class="head">
				<div></div>
				<span>{{$t('display')}}</span>
				<div></div>
			</div>
			<div class="swiper mySwipers">
				<img src="../assets/images/prev1.png" @click="prev" class="btn prev" />
				<img src="../assets/images/next1.png" @click="next" class="btn next" />
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="v in list" :key="v.uuid">
						<div class="label">
							<div @click.stop="itemFn(v)">
								<div class="pic"><img :src="v.underlayUrl + '?x-image-process=image/resize,w_1200,limit_0'" /></div>
								<span>{{ v['name' + En] }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>        
			<em class="syn"><i>{{ $t('startTime') }}</i> <i>{{ $t('location') }}</i></em>
		</div>
	</div>
</template>

<script>
import protal from "@/api/protal";
import router from "../router";
import { mapState } from "vuex";
export default {
    name: "display",
    data() {
        return {
            list: []
        };
    },
	computed: {
		...mapState({
			ExhibitDetail: state => state.ExhibitDetail
		})
	},
    created() {
        this.getWebHomeExhibit();
    },
    methods: {
		itemFn(v) {
			this.$router.push({path:'/zhanlan',query:{uuid:v.uuid}})
			const headList = this.$store.state.headList
			const headIndex = this.$store.state.headIndex
			this.$jsAPI('track', 'ciif_gbzyExhibitionListClick', {
				contentID_var: v.uuid,
				contentName_var: v.name,
				firstNavigationName_var: headList[headIndex].name,
				secondNavigationName_var: headList[headIndex].children && headList[headIndex].children.length ? localStorage.getItem('leftIndex') : ''
			})
		},
        // 官网查询专业展知名展商
        getWebHomeExhibit() {
            protal.getWebHomeExhibit().then(r => {
                this.list = r.data;
                if (this.isPc) {
                    this.$nextTick(function () {
                        this.swiper = new Swiper(".mySwipers", {
                            slidesPerView: "auto",
                            loop: true,
                            speed: 600, // 滑动速度
                        });
                    });
                }
                else {
                    this.$nextTick(function () {
                        this.swiper = new Swiper(".mySwipers", {
                            slidesPerView: "auto",
                            loop: true,
                            centeredSlides: true,
                            speed: 600, // 滑动速度
                        });
                    });
                }
            });
        },
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();
        }
    },
    components: { router }
}
</script>

<style lang="less" scoped="scoped">
.btn {
	display: none;
	width: .48rem;
	position: absolute;
	top: 50%;
	z-index: 999;
	transform: translateY(-50%);

	&:hover {
		opacity: 0.8;
	}

	&.prev {
		left: .28rem;
	}

	&.next {
		right: .28rem;
	}
}

.main_display {
	overflow: hidden;
	width: 100%;
	background: #071320;
	padding: 1.06rem 0 .8rem 0;

	.m {
		width: 14.4rem;
		margin: 0 auto;

		em {
			display: flex;
			text-align: center;
			
			align-items: center;
			justify-content: center;
			
			margin-top: .4rem;
			i{
				color: #FFFFFF;
			font-size: .2rem;
			font-family: syn;
			margin: 0 .16rem;
			}
		}

		.mySwipers {
			width: 100%;
			overflow: hidden;
			margin-top: .26rem;

			.swiper-slide {
				width: 10.13888888888889%;
				background: #F0F0F0;
				margin-top: .3rem;
				margin-right: calc((100% - 91.25%)/8);

				.label {
					width: 100%;

					.pic {
						overflow: hidden;
						width: 100%;
						height: 1.44rem;

						img {
							width: 100%;
							height: 100%;
							object-fit: cover;
							display: block;
						}
					}

					&:hover {
						span {
							color: #FC581C;
						}
					}

					span {
						display: flex;
						align-items: center;
						justify-content: center;
						font-size: .12rem;
						height: .64rem;
						text-align: center;
						padding: 0 .1rem;
						transition: all .1s;
						box-sizing: border-box;
						font-family: '"微软雅黑"';
						color: #737373;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
				}
			}
		}

		.head {
			display: flex;
			align-items: center;
			justify-content: center;

			div {
				width: .86rem;
				height: .02rem;
				background: #fff;
			}

			span {
				font-size: .4rem;
				margin: 0 .28rem;
				color: #fff;
				line-height: 1;
				font-family: syb;
			}
		}
	}
}

@media screen and (max-width: 900px) {
	.main_display {
		padding: .72rem 0 .6rem 0;
	}

	.main_display .m {
		width: 100%;
	}

	.btn {
		display: block;
		width: .48rem;
		z-index: 999;
	}

	.main_display .m .mySwipers .swiper-slide {
		width: 1.8rem;
		margin: 0 .12rem;
	}

	.main_display .m .mySwipers .swiper-slide .label .pic {
		height: 1.8rem;
	}

	.main_display .m .mySwipers .swiper-slide .label span {
		font-size: .16rem;
		color: #737373;
		line-height: .3rem;
		height: .78rem;
		font-family: syn;
	}

	.btn.prev {
		left: .28rem;
	}

	.btn.next {
		right: .28rem;
	}

	.main_display .m .head span {
		font-size: .36rem;
		margin: 0 .2rem;
	}

	.main_display .m .head div {
		width: .6rem;
		height: 2px;
	}

	.main_display .m .mySwipers {
		position: relative;
		margin-top: .6rem;

		&::after {
			content: '';
			width: 2rem;
			height: 100%;
			position: absolute;
			left: 0;
			top: 0;
			background: linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0));
			z-index: 99;
		}

		&::before {
			content: '';
			width: 2rem;
			height: 100%;
			position: absolute;
			right: 0;
			top: 0;
			background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5));
			z-index: 99;
		}
	}

	.main_display .m em {
		font-size: .22rem;
		margin-top: .56rem;
		font-family: syn;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/display.vue